<template>
    <div v-if="isLoading" class="loading-overlay"><p>Carregando...</p></div>

    <div class="form-edit-page">
        <form @submit.prevent="submitForm">
            <div class="row row-space">
                <div class="form-item" style="flex: 0 0 90px;">
                    <label class="label-caption">Código</label>
                    <div class="field-label field-label-end">{{ objEdicao.cdprograma }}</div>
                </div>
                
                <div class="form-item flexible">
                    <label class="label-caption">Nome</label>
                    <input type="text" v-model="objEdicao.nmprograma" required maxlength="100" v-uppercase />
                </div>
            </div>


            <div class="row row-space">
                <div class="form-item">
                    <label class="label-caption">Valor Base</label>
                    <input v-model="edVlCupom" v-decimal type="text" />
                </div>

                <div class="form-item">
                    <label class="label-caption">Cupom Fiscal</label>
                    <input v-model="edVlCupomCf" v-decimal type="text" />
                </div>

                <div class="form-item">
                    <label class="label-caption">Nota Fiscal</label>
                    <input v-model="edVlCupomNf" v-decimal type="text" />
                </div>

                <div class="form-item">
                    <label class="label-caption">Nota de Serviço</label>
                    <input v-model="edVlCupomNs" v-decimal type="text" />
                </div>
                
                <div class="form-item">
                    <label class="label-caption">Nota de Produtor</label>
                    <input v-model="edVlCupomNp" v-decimal type="text" />
                </div>
            </div>


            <div class="row row-space">
                <div class="form-item">
                    <label class="label-caption">Observações</label>
                    <textarea v-model="objEdicao.observacoes" maxlength="1000" rows="5" style="resize: none;"/>
                </div>
            </div>


            <div class="row-end">
                <label for="ckAtivo">Ativo</label>
                <input id="ckAtivo" type="checkbox" class="input-checkbox" v-model="ckAtivo" />
            </div>


            <div class="row-end margin-top10">
                <button class="btn-confirm" type="submit">Salvar</button>
                <button class="btn-cancel" type="cancel" @click="cancelForm">Cancelar</button>
            </div>
        </form>
    </div>
</template>
  
<script setup>
import { onMounted, ref } from 'vue';
import { Api } from '@/funcoes/apiExport';
import { criarPrograma } from '@/models/Programa';
import { globalStore } from '@/globals';
import { Funcoes } from '@/funcoes/utils';

const emit = defineEmits(['close', 'salvo']);
const props = defineProps({idEdicao: {type: Number, default: 0}});

const ckAtivo = ref(false);
const edVlCupom = ref(null);
const edVlCupomCf = ref(null);
const edVlCupomNf = ref(null);
const edVlCupomNs = ref(null);
const edVlCupomNp = ref(null);
const objEdicao = criarPrograma();
const isLoading = ref(false);

const submitForm = async () => {
    try {
        objEdicao.ckativo          = ckAtivo.value ? 'S' : 'N';
        objEdicao.vlcupom          = Funcoes.decimalFromString(edVlCupom.value);
        objEdicao.vlcupom_cf       = Funcoes.decimalFromString(edVlCupomCf.value);
        objEdicao.vlcupom_nf       = Funcoes.decimalFromString(edVlCupomNf.value);
        objEdicao.vlcupom_ns       = Funcoes.decimalFromString(edVlCupomNp.value);
        objEdicao.vlcupom_np       = Funcoes.decimalFromString(edVlCupomNs.value);
        const response = await Api.genericPut('/cad/programa', objEdicao);
        if (response.bolok === 1){
            emit('salvo');
            emit('close');
        }else{
            alert(response.erro);
        }
    } catch (error) {console.error('Error:', error);}
};

const cancelForm = () => {emit('close');};

const lerDados = async() => {
    try{
        isLoading.value=true;
        if (props.idEdicao > 0) {
            try{
                const req = await Api.getCadastroById('programa', props.idEdicao);
                Object.assign(objEdicao, req[0]);
                edVlCupom.value         = Funcoes.formatDecimal(objEdicao.vlcupom);
                edVlCupomCf.value       = Funcoes.formatDecimal(objEdicao.vlcupom_cf);
                edVlCupomNf.value       = Funcoes.formatDecimal(objEdicao.vlcupom_nf);
                edVlCupomNs.value       = Funcoes.formatDecimal(objEdicao.vlcupom_np);
                edVlCupomNp.value       = Funcoes.formatDecimal(objEdicao.vlcupom_ns);
            }catch (error){console.error('Erro leitura dos dados', error);}
        }else{
            objEdicao.idmunicipio = globalStore.idmunicipio;
        }
        objEdicao.idusuario   = globalStore.idusuario;
        ckAtivo.value         = objEdicao.ckativo === 'S';
    }finally{isLoading.value=false;}
};

onMounted(lerDados);
</script>